import React from "react";
import { FaArrowLeft } from 'react-icons/fa';


const PageLayout = ({
  children,
  onBack,
  onProceed,
  proceedDisabled,
  showFooter = true,
}) => (
  <div className="sheets-stack" id="sheetsStack">
    {/* (Optional) Header section can be added here */}

    <main>
      {children}
    </main>

    
  </div>
);

export default PageLayout;
